import { ICreateScheduledPush, IEditScheduledPush, IGetPaginatedScheduledPushes } from 'types';
import {
	serviceGetScheduledPushInfo,
	serviceCreateScheduledPush,
	serviceEditScheduledPush,
	serviceGetPaginatedScheduledPushes,
	serviceDeleteScheduledPush,
} from 'services/api/pushes';
import { createAppErrorMessage } from 'utils/helpers';

const getScheduledPushInfo = async (pushID: string) => {
	try {
		const response = await serviceGetScheduledPushInfo(pushID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createScheduledPush = async (data: ICreateScheduledPush) => {
	try {
		await serviceCreateScheduledPush(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingScheduledPush');
		throw new Error(errorMessage);
	}
};

const editScheduledPush = async (data: IEditScheduledPush) => {
	try {
		await serviceEditScheduledPush(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingScheduledPush');
		throw new Error(errorMessage);
	}
};

const getPaginatedScheduledPushes = async (args: IGetPaginatedScheduledPushes) => {
	try {
		const response = await serviceGetPaginatedScheduledPushes(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const deleteScheduledPush = async (pushID: string) => {
	try {
		await serviceDeleteScheduledPush(pushID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingScheduledPush');
		throw new Error(errorMessage);
	}
};

export {
	getScheduledPushInfo,
	createScheduledPush,
	editScheduledPush,
	getPaginatedScheduledPushes,
	deleteScheduledPush,
};
